import { LocaleEnum } from '@systemeio/ui-frontend'
import { httpClient } from './http-client'

export function changeLanguage(locale: LocaleEnum) {
  return httpClient.post('/api/user/change-language', { language: locale })
}
